import { render } from "./Doyouknow.vue?vue&type=template&id=473f46c6"
import script from "./Doyouknow.vue?vue&type=script&scoped=true&lang=js"
export * from "./Doyouknow.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__